import { createFileRoute } from '@tanstack/react-router';

type Search = {
  contactId?: string;
  selectedLocationId?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/fax/drafts/$draftId')({
  validateSearch: (search: Partial<Search>): Search => {
    return {
      selectedLocationId: search.selectedLocationId,
    };
  },
});
